var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},_vm._l((_vm.itoContents),function(item){return _c('div',{key:item.id,staticClass:"box"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(item.title))]),_vm._l((item.content),function(items){return _c('div',{key:items.index,staticClass:"content"},[_vm._v(" "+_vm._s(items)+" ")])})],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }